<script>
const tagName = 'base-icon';

export function loadIcon(name) {
  // @note we can't use `await import()` here because we can't async render.
  const icon = require('@/assets/icons/' + name + '.svg');
  return icon && icon.default ? icon.default : icon;
}

export default {
  name: tagName,
  functional: true,
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
  },
  render(h, vm) {
    const icon = loadIcon(vm.props.name);
    if (icon) {
      const vnode = icon.render(h, vm);
      if (vnode.data && vnode.data.class) {
        vnode.data.class.unshift(tagName);
      }

      vnode.data.style = {
        ...(vnode.data.style || {}),
        ...(vm.props.color ? { color: vm.props.color } : {}),
      };

      // Forward passthrough attributes (e.g. aria-hidden, aria-label, role) onto the SVG.
      vnode.data.attrs = {
        ...(vnode.data.attrs || {}),
        ...(vm.data.attrs || {}),
      };

      return vnode;
    }

    return undefined;
  },
};
</script>

<style lang="scss"></style>
